<template>
    <div class="primary--text">
        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t('tipo_fachada')}}
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c propiedad="code" nombre="name" :items="fachadasSeleccionValidas"
                                          :cargando="cargandoFachadas"
                                          v-model="fachadaSeleccionada" @change="seleccionarFachada">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t('aislante')}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Elección del tipo de material que se desea incorporar a la solución constructiva como aislante térmico</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c v-if="fachadaSeleccionada != null || cargandoAislantes"
                                          propiedad="code" nombre="name" :items="aislantesSeleccionValidos"
                                          :cargando="cargandoAislantes"
                                          v-model="aislanteSeleccionado" @change="seleccionarAislante">
                </seleccion-componente-s-c>
                <div class="caption pa-2" v-if="fachadaSeleccionada == null && !cargandoAislantes">
                    {{$t('tipo_fachada_antes')}}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {HttpHelper} from "../../../../../../../comunes/helpers/HttpHelper";
    import SeleccionComponenteSC from "../../Componentes/SeleccionComponenteSC";

    export default {
        name: "ComponentesFachadaR",
        components: {
            SeleccionComponenteSC
        },
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            solucionConstructiva: {type: Object, required: true},
            proyectoId: {type: Number, required: true},
            fachadas: {type: Array, required: true},
            aislantes: {type: Array, required: true},
            correcto: {type: Boolean, default: false},
        },
        data: function () {
            return {
                cargandoFachadas: false,
                fachadaSeleccionada: null,
                fachadasCodigosValidas: [],
                fachadasSeleccionValidas: [],
                cargandoAislantes: false,
                aislanteSeleccionado: null,
                aislantesCodigosValidos: [],
                aislantesSeleccionValidos: []
            }
        },
        mounted() {
            this.cargarPorDefecto();

            let promesas = [];
            promesas.push(this.cargarTiposFachadaValidos());
            promesas.push(this.cargarAislantesValidos());

            Promise.all(promesas).then(() => {
                this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
            });
        },
        watch: {
            solucionConstructiva: {
                handler() {
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                },
                deep: true
            }
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cargarTiposFachadaValidos() {
                let materialId = this.solucionConstructiva.materialDermis.id;
                let url = `fachada/rehabilitacion/tipo-fachada/por-material/${materialId}`;
                this.fachadasCodigosValidas = [];
                this.fachadasSeleccionValidas = [];
                this.cargandoFachadas = true;
                return new Promise((resolve) => {
                    HttpHelper.get(url)
                        .then(data => {
                            data.forEach((type) => {
                                this.fachadasCodigosValidas.push(type.code);
                                this.fachadasSeleccionValidas.push(type);
                            });

                            if (this.fachadaSeleccionada != null
                                && !this.fachadasCodigosValidas.includes(this.fachadaSeleccionada.code)) {
                                this.fachadaSeleccionada = null;
                            }
                            resolve();
                        })
                        .finally(() => {
                            this.cargandoFachadas = false;
                        });
                });
            },
            cargarAislantesValidos() {
                return new Promise((resolve) => {
                    this.aislantesCodigosValidos = [];
                    this.aislantesSeleccionValidos = [];
                    if (this.fachadaSeleccionada == null) return;

                    let fachada = this.fachadaSeleccionada.code;
                    this.cargandoAislantes = true;

                    let url = `fachada/rehabilitacion/aislante/por-tipo-fachada/${fachada}`;
                    HttpHelper.get(url)
                        .then(data => {
                            data.forEach((type) => {
                                this.aislantesCodigosValidos.push(type.code);
                                this.aislantesSeleccionValidos.push(type);
                            });
                            if (this.aislanteSeleccionado != null
                                && !this.aislantesCodigosValidos.includes(this.aislanteSeleccionado.code)) {
                                this.aislanteSeleccionado = null;
                            }
                            resolve();
                        })
                        .finally(() => {
                            this.cargandoAislantes = false;
                        });
                });
            },
            seleccionarFachada: function (item) {
                if (!this.fachadasCodigosValidas.includes(item.code)) return;
                this.solucionConstructiva.typeFacade = item;
                this.cargarAislantesValidos();
            },
            seleccionarAislante: function (item) {
                if (!this.aislantesCodigosValidos.includes(item.code)) return;
                this.solucionConstructiva.insulating = item;
            },
            solucionConstructivaEsCorrecta(solucionConstructiva) {
                if (solucionConstructiva.typeFacade === null ||
                    !this.fachadasCodigosValidas.includes(solucionConstructiva.typeFacade.code)) return false;

                if (solucionConstructiva.insulating === null || (this.aislantesCodigosValidos.length > 0 &&
                    !this.aislantesCodigosValidos.includes(solucionConstructiva.insulating.code)))
                    return false;

                return true;
            },
            cargarPorDefecto() {
                this.fachadaSeleccionada = this.solucionConstructiva.typeFacade;
                this.aislanteSeleccionado = this.solucionConstructiva.insulating;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "tipo_fachada": "Tipo de fachada",
    "aislante": "Aislante",
    "tipo_fachada_antes": "Se debe seleccionar el tipo de fachada antes"
    }
    }
</i18n>
<!--@formatter:on-->